<template lang="pug">
modal#approve-envelope-modal(
  :no-footer='isPublic && !isBradescoVersion'
  :process-button-label='$t("button.ok")'
  :show-cancel-button='false'
  :title='$t("modal.approveEnvelope.title")'
  @closed='closeModal'
  @process='goToInboxPage'
  ref='modal'
)
  .text {{ $t('modal.approveEnvelope.message', { subject: getSubject }) }}
  .text {{ $t('modal.approveEnvelope.message2') }}
  .text {{ $t('modal.approveEnvelope.message3') }}
  .text-center.mt-4
    img.img-fluid.mb-4(src='/img/ilustrations/approve-document.svg')
  div(v-if='isPublic && !isBradescoVersion')
    buttons-login-and-create-account.mt-4
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import ButtonsLoginAndCreateAccount from '@/modules/business/components/molecules/ButtonsLoginAndCreateAccount.vue';
import ApplicationService from '@/services/ApplicationService';

export default {
  name: 'ApproveEnvelopeModal',
  components: {
    Modal,
    ButtonsLoginAndCreateAccount,
  },
  props: {
    isPublic: {
      type: Boolean,
      default: false,
    },
    subject: {
      type: String,
      default: '',
    },
  },
  computed: {
    getSubject() {
      return this.subject || this.$t('modal.approveEnvelope.noSubject');
    },
    closeButtonLabel() {
      return this.isPublic && !this.isBradescoVersion
        ? ''
        : this.$t('button.ok');
    },
    isBradescoVersion() {
      return ApplicationService.isSelfRegistrationBlock();
    },
  },
  methods: {
    goToInboxPage() {
      this.$router.push({ name: 'business.documents.inbox' });
    },
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
